import { gql } from '@apollo/client';

export const GET_TEMU_LABEL_FOR_RELABEL = gql`
    query GetTemuLabelForRelabel($collectionWaybillSn: String!) {
        getTemuLabelForRelabel(collectionWaybillSn: $collectionWaybillSn) {
            pdfBase64
            tailWaybillSn
        }
    }
`;

export interface TemuRelabelLabelResult {
    pdfBase64: string;
    tailWaybillSn?: string | null;
}

export interface GetTemuLabelForRelabelResponse {
    getTemuLabelForRelabel: TemuRelabelLabelResult | null;
}

export interface GetTemuLabelForRelabelVariables {
    collectionWaybillSn: string;
}
